import './App.scss';
import { useLocation, Routes, Route } from 'react-router-dom';
import { useState, useEffect } from 'react';
import { Button } from 'react-bootstrap';
import { ChevronUp } from 'react-bootstrap-icons';
import Navigation from './components/Navigation';
import HomeBanner from './components/HomeBanner';
import CareerBanner from './components/CareerBanner';
import Career from './pages/Career';
import Home from './pages/Home';
import Footer from './components/Footer';
import PreInterviewForm from './pages/PreInterviewForm';
import PreInterviewDesinger from './pages/PreInterviewDesinger';
import AgroCaseStudy from "./pages/AgroCaseStudy";
import WhatsAppButton from './components/WhatsAppButton';
import DentalProtectionCaseStudy from "./pages/DentalProtectionCaseStudy";
import AureliaHeightsCaseStudy from "./pages/AureliaHeightsCaseStudy";
import GlamoraCaseStudy from './pages/GlamoraCaseStudy';
import PushpanjaliCaseStudy from './pages/PushpanjaliCaseStudy';
import AyushreemCaseStudy from './pages/AyushreemCaseStudy';
import BendreJewellersCaseStudy from './pages/BendreJewellersCaseStudy';
import BhumirajSweetCaseStudy from './pages/BhumirajSweetCaseStudy';

function App() {
  const [scrolled, setScrolled] = useState(false);
  const location = useLocation();

  useEffect(() => {
    const handleScroll = () => {
      setScrolled(window.scrollY > 100);
    };

    window.addEventListener('scroll', handleScroll);

    return () => {
      window.removeEventListener('scroll', handleScroll);
    };
  }, []);

  return (
    <>
     <div className="hero-gradient">
        <Navigation />
        {location.pathname === "/" && <HomeBanner />}
        {location.pathname === "/career" && <CareerBanner />}
        {location.pathname === "/career/pre-interview-form" && <CareerBanner />}
        {location.pathname === "/career/pre-interview-desinger" && <CareerBanner />}
      </div>
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/career" element={<Career />} />
        <Route path="/career/pre-interview-form" element={<PreInterviewForm />} />
        <Route path="/career/pre-interview-desinger" element={<PreInterviewDesinger />} />
        <Route
          path="/work/case-study/agro-industries"
          element={<AgroCaseStudy />}
        />
        <Route
          path="/work/case-study/dental-protection"
          element={<DentalProtectionCaseStudy />}
        />
        <Route
          path="/work/case-study/aurelia-heights"
          element={<AureliaHeightsCaseStudy />}
        />
        <Route
          path="/work/case-study/glamora"
          element={<GlamoraCaseStudy />}
        />
        <Route
          path="/work/case-study/pushpanjali-dresses"
          element={<PushpanjaliCaseStudy />}
        />
        <Route
          path="/work/case-study/ayushreem"
          element={<AyushreemCaseStudy />}
        />
        <Route
          path="/work/case-study/bendre-jewellers"
          element={<BendreJewellersCaseStudy />}
        />
        <Route
          path="/work/case-study/bhumiraj-sweet"
          element={<BhumirajSweetCaseStudy />}
        />
        
      </Routes>
      <Footer />
      <Button
        className={`scroll-top-btn ${scrolled ? 'visible' : ''}`}
        href="#root"
      >
        <ChevronUp />
      </Button>
     <WhatsAppButton />
    </>
  );
}

export default App;